import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Locale, BrandModel } from "../frame/index.js";
import { Config } from "../service/index.js";
import { Navbar } from "./Navbar.jsx";
import { Sidebar, SidebarErrataView, SidebarLoaderView } from "./Sidebar.jsx";
import { setMenuAction } from "../../src/redux/actions/actions.js";
export { SidebarLoader };
const local = new Locale("SidebarLoader", {
  invalid_response: "Некорректный ответ от сервера {path}: {response}",
});
const service = Config.createService("student_service");
/**
 * Загружает и отображает боковую панель.
 *
 * @summary Загружает и отображает боковую панель.
 * @param {Object} props - Атрибуты элемента.
 * @param {JSX.Element} props.children - Основное содержимое страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link StudioFrame.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function SidebarLoader({ onSignOut, children }) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId, vuzId } = useSelector((state) => state.contract);
  const dispatch = useDispatch();
  const request = {
    method: "post",
    path: "/personal/menu",
    data: {
      access_token: access_token,
      study_contract_id: contractId,
    },
  };
  const [response, setResponse] = React.useState(null);

  React.useEffect(() => {
    async function getMenu() {
      const data = await service.send(request, setResponse);
      if (!data.errors) {
        dispatch(setMenuAction(data));
      }
    }
    getMenu();
  }, [access_token, contractId]);
  if (!response) return <SidebarLoaderView>{children}</SidebarLoaderView>;
  if (response.errors)
    return <SidebarErrataView errata={response}>{children}</SidebarErrataView>;
  if (response.length) {
    const brand = new BrandModel({});
    brand.setLogo(vuzId);
    const navbar = <Navbar handleSignOut={onSignOut} />;
    return (
      <Sidebar
        brand={brand}
        menu={response}
        navbar={navbar}
        onSignOut={onSignOut}
      >
        {children}
      </Sidebar>
    );
  } else {
    const error_message = local.message("invalid_response", {
      path: request.path,
      response: JSON.stringify(response),
    });
    const errata = {
      error_type: "ajax",
      errors: [error_message],
    };
    return <SidebarErrataView errata={errata}>{children}</SidebarErrataView>;
  }
}
